import { useSnackbar } from 'notistack'
import { BaseSyntheticEvent, useContext, useEffect } from 'react'
import { useTranslation } from 'react-i18next'

import { Form } from 'components/Form'
import { AbTestsAddEditContext } from 'features/ab-tests/contexts/AbTestsAddEditContext'
import { useCreateAbTest } from 'features/ab-tests/hooks/useCreateAbTest'
import { AbTestsCommonForm } from '../AbTestsCommonForm'
import { abTestsAddSchema, abTestsAddSchemaDefaults } from './abTestsAddSchema'

import type { AbTestsAddSchema } from './abTestsAddSchema'
import type { AbTestsAddEditContextType } from 'features/ab-tests/contexts/AbTestsAddEditContext'

export const AbTestsAddForm = (): JSX.Element => {
  const { enqueueSnackbar } = useSnackbar()
  const { t } = useTranslation('features/abTests')

  const { formId, loading, setTouched, setValid } =
    useContext<AbTestsAddEditContextType>(AbTestsAddEditContext)

  const { create, errors } = useCreateAbTest()

  const submitHandler = (data: AbTestsAddSchema, event?: BaseSyntheticEvent): void => {
    const submitterId: string | undefined = (event?.nativeEvent as SubmitEvent).submitter?.id

    if (submitterId === undefined) throw new Error('submitterId is missing')

    void create({
      ...data,
      status: submitterId.endsWith('save-and-start-button') ? 'active' : 'draft',
    })
  }

  useEffect(() => {
    if (loading) {
      enqueueSnackbar(t('form.saving'), { variant: 'info' })
    }
  }, [loading])

  return (
    <Form<AbTestsAddSchema>
      externalErrors={errors}
      id={formId}
      onSubmit={submitHandler}
      onTouched={setTouched}
      onValid={setValid}
      schema={abTestsAddSchema}
      schemaDefaults={abTestsAddSchemaDefaults}
    >
      {() => <AbTestsCommonForm variant='add' />}
    </Form>
  )
}
